var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialog.visible,
            "append-to-body": "",
            "modal-append-to-body": false,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
            closed: _vm.beforeClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.params,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "公司名称：", prop: "companyName" } },
                [
                  _c("el-input", {
                    staticStyle: { "padding-right": "-30px" },
                    attrs: {
                      maxlength: "99",
                      "show-word-limit": "",
                      placeholder: "请输入公司名称",
                    },
                    model: {
                      value: _vm.params.companyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "companyName", $$v)
                      },
                      expression: "params.companyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "公司备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 99 },
                      maxlength: "999",
                      "show-word-limit": "",
                      placeholder: "请输入公司备注",
                    },
                    model: {
                      value: _vm.params.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "remark", $$v)
                      },
                      expression: "params.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { staticStyle: {}, attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.hide } }, [_vm._v("取 消")]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }